import { useEffect, useState } from 'react';
import { applyServiceWorkerUpdate } from '@/serviceWorkerRegistration';

/**
 * PWAUpdatePrompt
 * - Shows a small bottom-left toast when a new SW is waiting (sw-update-available).
 * - Shows an offline indicator when navigator.onLine is false.
 */
export default function PWAUpdatePrompt() {
  const [registration, setRegistration] = useState(null);
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const onUpdate = (e) => setRegistration(e.detail?.registration ?? null);
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);

    window.addEventListener('sw-update-available', onUpdate);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('sw-update-available', onUpdate);
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return (
    <>
      {!online && (
        <div
          data-testid="pwa-offline-indicator"
          className="fixed left-4 bottom-20 z-[9998] flex items-center gap-2 rounded-full bg-red-600/95 px-3 py-1.5 text-xs font-semibold text-white shadow-lg backdrop-blur"
        >
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-white" />
          Offline
        </div>
      )}

      {registration && (
        <div
          data-testid="pwa-update-prompt"
          className="fixed left-4 bottom-4 z-[9999] flex items-center gap-3 rounded-xl border border-emerald-500/30 bg-emerald-950/95 px-4 py-3 text-sm text-emerald-50 shadow-2xl backdrop-blur"
        >
          <span>A new version is available.</span>
          <button
            data-testid="pwa-update-btn"
            onClick={() => applyServiceWorkerUpdate(registration)}
            className="rounded-md bg-emerald-500 px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-emerald-400"
          >
            Update
          </button>
        </div>
      )}
    </>
  );
}
